import React from 'react';
import { Search, ShieldCheck, MapPin, Wrench, Package, Clock, Truck } from 'lucide-react';
const CHIPS = [{
  label: 'Complete mailbox system',
  href: '/6m8/mailboxes/complete-mailbox-post-system.html'
}, {
  label: 'Locking mailbox',
  href: '/6m8/mailboxes/locking-mailboxes.html'
}, {
  label: 'Commercial CBU',
  href: '/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html'
}, {
  label: 'Replacement part',
  href: '/6m8/mailboxes/mailbox-replacement-parts-and-accessories.html'
}, {
  label: 'Address plaque',
  href: '/6m8/address-plaques-and-house-numbers.html'
}, {
  label: 'Mailbox post',
  href: '/6m8/mailbox-posts.html'
}];
export function Hero() {
  return <section className="relative bg-brand-background overflow-hidden border-b border-brand-border" data-id="element-359" data-mp="1v4et0t3t6jq4">
      <div className="max-w-7xl mx-auto px-4 py-8 lg:py-12" data-id="element-360" data-mp="1q5al05smes1d">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center" data-id="element-361" data-mp="1q5tvx2jusg5w">
          {/* Left Column: Content */}
          <div className="lg:col-span-7 relative z-10" data-id="element-362" data-mp="1myp1vbt4uzoe">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-363" data-mp="1rw712ahcm0j7">
              Residential, commercial & custom mailbox systems
            </span>

            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-4 leading-tight text-balance" data-id="element-364" data-mp="25n3pdp48rvkg">
              The Right Mailbox for Your Home, Community, or Business
            </h1>

            <p className="text-base lg:text-lg text-brand-muted mb-6 leading-relaxed text-balance max-w-2xl" data-id="element-365" data-mp="1vvzfh3tfb0wh">
              Shop residential mailboxes, commercial delivery systems,
              replacement parts, address plaques, signs, lighting, and exterior
              accents — with expert help before you order.
            </p>

            {/* Compact selling points — placed above the search box so both
                messages land in the first viewport on mobile and desktop. */}
            <ul className="flex flex-col sm:flex-row sm:flex-wrap gap-2 mb-6 max-w-2xl" data-id="element-366" data-mp="2y9270w69fcxg">
              <li className="inline-flex items-center gap-2 bg-white border border-brand-border rounded-full pl-3 pr-4 py-1.5 text-sm text-brand-charcoal" data-id="element-367" data-mp="2u773rm4rqph1">
                <Truck size={15} className="text-brand-maroon shrink-0" aria-hidden="true" data-id="element-368" data-mp="2paq6a1boiyra" />
                <span className="font-medium" data-id="element-369" data-mp="2fi0xje7ijyzn">
                  Free shipping on commercial mailbox systems
                </span>
              </li>
              <li className="inline-flex items-center gap-2 bg-white border border-brand-border rounded-full pl-3 pr-4 py-1.5 text-sm text-brand-charcoal" data-id="element-370" data-mp="26i4fvwjjk0e3">
                <Clock size={15} className="text-brand-maroon shrink-0" aria-hidden="true" data-id="element-371" data-mp="21hq90htoewhn" />
                <span className="font-medium" data-id="element-372" data-mp="c2fga4c4hlk3">
                  After-hours support until 8 PM ET:{' '}
                  <a href="tel:240-575-5852" className="text-brand-maroon hover:underline" data-id="element-373" data-mp="h07jvvm4qw44">
                    240-575-5852
                  </a>
                </span>
              </li>
            </ul>

            {/* Hero Search Panel */}
            {/* TODO: wire form action to Website Forge search endpoint */}
            <form role="search" onSubmit={e => e.preventDefault()} className="bg-white p-2 rounded-lg shadow-sm border border-brand-border mb-3 flex flex-col sm:flex-row gap-2 max-w-2xl" data-id="element-374" data-mp="3ufww7mf08spn">
              <div className="relative flex-grow" data-id="element-375" data-mp="73mcx4qjvaxn">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-376" data-mp="36qay72adcjj8" />
                <input type="text" aria-label="Search 1,700+ products by name, brand, part, or spec" placeholder="Search 1,700+ products by name, brand, part, or spec" className="w-full pl-10 pr-4 py-3 rounded-md border-none focus:ring-2 focus:ring-brand-maroon/50 bg-transparent text-brand-charcoal placeholder-gray-500 font-medium" data-id="element-377" data-mp="3aqd09ck0nez1" />
              </div>
              <button type="submit" aria-label="Search" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-8 py-3 rounded-md font-semibold transition-colors whitespace-nowrap shadow-sm" data-id="element-378" data-mp="3adsm047u0647">
                Search
              </button>
            </form>

            {/* Quick Chips */}
            <div className="flex flex-wrap gap-2 mb-8 max-w-2xl" data-id="element-379" data-mp="3fdn8zwohkbjz">
              {CHIPS.map(chip => <a key={chip.label} href={chip.href} className="text-xs font-medium bg-white hover:bg-brand-goldWash text-brand-muted hover:text-brand-charcoal hover:border-brand-gold px-3 py-1.5 rounded-full border border-brand-border transition-colors" data-id="element-380" data-mp="1py7arcc3oa8v">
                  {chip.label}
                </a>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-wrap items-center gap-4" data-id="element-381" data-mp="3rv7uk7arewuf">
              <a href="#shop-by-need" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-6 py-3 rounded-md font-bold transition-colors shadow-sm" data-id="element-382" data-mp="3rtel6k8rhyiq">
                Shop by Project
              </a>
              <a href="/ContactUs.html" className="bg-white hover:bg-brand-panel text-brand-charcoal border border-brand-border px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-383" data-mp="33yk7nzqfmsbc">
                Get Help Choosing
              </a>
              <span className="hidden sm:inline text-gray-400" data-id="element-384" data-mp="175s63iz0jk7y">or</span>
              <a href="tel:301-620-7585" className="text-brand-charcoal hover:text-brand-maroon font-semibold flex items-center gap-2 transition-colors" data-id="element-385" data-mp="15o3aorp9b7dd">
                Call 301-620-7585
              </a>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="lg:col-span-5 relative hidden lg:block h-full min-h-[520px]" data-id="element-386" data-mp="qrc7e7cgpbih">
            <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-sm border border-brand-border" data-id="element-387" data-mp="1oeb7yt69z3ln">
              <img src="https://cdn.magicpatterns.com/uploads/fJqLQeKXo2Tu7545LSyHzm/hero-mailbox-black-traditional-mount-kit-photoreal.jpg" alt="Black Traditional Mount Kit mailbox and post installed in front of a residential home" className="w-full h-full object-cover object-center" data-id="element-388" data-mp="1jeyehpkweya3" />
            </div>
          </div>
        </div>
      </div>

      {/* Trust Strip - Compact */}
      <div className="bg-white border-t border-brand-border" data-id="element-389" data-mp="22d1528t3h3a0">
        <div className="max-w-7xl mx-auto px-4 py-3" data-id="element-390" data-mp="2anrtkke73p2y">
          <div className="flex flex-wrap justify-center lg:justify-between items-center gap-x-8 gap-y-3 text-xs lg:text-sm text-brand-charcoal font-medium" data-id="element-391" data-mp="2apcle294ktx4">
            <div className="flex items-center gap-2" data-id="element-392" data-mp="2jmwq5l6758ch">
              <Package size={16} className="text-brand-maroon" data-id="element-393" data-mp="2omrd5dmupds9" />
              <span data-id="element-394" data-mp="2oo2l7pnbx7p6">Nationwide shipping</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-395" data-mp="2tmnhxf3dh98v"></div>
            <div className="flex items-center gap-2" data-id="element-396" data-mp="2xn7jcuuzaz0t">
              <Wrench size={16} className="text-brand-maroon" data-id="element-397" data-mp="2xlmmuzp3t60b" />
              <span data-id="element-398" data-mp="32dw8w4n3llxb">Select-area installation</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-399" data-mp="37d94bds1c1bi"></div>
            <div className="flex items-center gap-2" data-id="element-400" data-mp="37fd71se76ua7">
              <ShieldCheck size={16} className="text-brand-maroon" data-id="element-401" data-mp="3cd51ou688ui3" />
              <span data-id="element-402" data-mp="3hbgbj4wiv50b">22+ years of expertise</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-403" data-mp="3hbokwmtfrs6r"></div>
            <div className="flex items-center gap-2" data-id="element-404" data-mp="6fo8xtfe4mx8">
              <MapPin size={16} className="text-brand-maroon" data-id="element-405" data-mp="1hwfuw30eurg" />
              <span data-id="element-406" data-mp="1hmrte1iyxoe">USPS-aware guidance</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-407" data-mp="fhxkmmmeamc7"></div>
            <div className="flex items-center gap-2" data-id="element-408" data-mp="aiueeyuoia2n">
              <Clock size={16} className="text-brand-maroon" data-id="element-409" data-mp="ajdvyegf2wg5" />
              <span data-id="element-410" data-mp="3ixmjh8430x1g">Support until 8 PM ET</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-411" data-mp="3ewsu0aazra6g"></div>
            <div className="flex items-center gap-2" data-id="element-412" data-mp="3eynfbpq6d4b2">
              <Truck size={16} className="text-brand-maroon" data-id="element-413" data-mp="3soh4k95ldqlb" />
              <span data-id="element-414" data-mp="3sq22m8r47rnx">Free shipping on commercial mailbox systems</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}